module.exports = __webpack_public_path__ + "img/tuition_layout5.59f74e03.png";